<template>
  <div id="section-chart">
    <!-- Error and Information messages -->
    <div v-if="serverError" class="card-panel amber lighten-2" style="padding: 15px; position: relative;">
      <span class="material-icons" style="vertical-align: middle;">error</span>
      <span style="padding-left: 10px;">{{ $t('views.switch.alarmsettings.errorgettingdata') }}: {{ serverError }}</span>
      <span
        @click="serverError = ''"
        class="material-icons"
        style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"
      >
        close
      </span>
    </div>

    <div v-if="selectedAsset.ParentRailObjectId">
      <div class="row m-1 mt-3">
        <div class="col col-3">
          <b-form-select
            v-model="selectedPosition"
            :options="directions"
            value-field="id"
            text-field="name">
          </b-form-select>
        </div>
        <div class="col col-6" style="padding-top: 5px;">
          <label v-show="both">
            <input name="bothModeRight" class="with-gap" type="radio" :value=true  v-model="showNormalWhenBoth"/>
            <span>{{ $t('views.switch.sections.normal') }}</span>
          </label>
          <label v-show="both">
            <input name="bothModeLeft" class="with-gap" type="radio" :value=false  v-model="showNormalWhenBoth"/>
            <span>{{ $t('views.switch.sections.reverse') }}</span>
          </label>
        </div>
      </div>
      <div class="row" v-show="showNormalWhenBoth || both==false">
        <div class="col cssGraph">
          <div v-if="loading" class="spinner" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"></div>
          <highcharts v-else :options="sectionChartOptions"></highcharts>
        </div>
      </div>
      <div class="row" v-show="!showNormalWhenBoth && both==true" >
        <div class="col cssGraph">
          <div v-if="loading" class="spinner" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"></div>
          <highcharts v-else :options="sectionChartOptionsSecond"></highcharts>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <table class="table">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">#</th>
                <!-- <th scope="col" class="col-variable-section" @click="setVariableSectionStart(null)">
                  <b-icon icon="arrow-bar-left"></b-icon>
                </th>
                <th scope="col" class="col-variable-section" @click="setVariableSectionEnd(null)">
                  <b-icon icon="arrow-bar-right"></b-icon>
                </th> -->
                <th scope="col">{{ $t('views.switch.sections.section') }}</th>
                <th scope="col"></th>
                <th scope="col">{{ $t('views.switch.sections.start') }}</th>
                <th scope="col">{{ $t('views.switch.sections.end') }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <draggable v-model="sections" tag="tbody" handle=".handle" @end="endSort">
              <tr v-for="(section, index) in sections"
                  v-bind:key="section.name"
                  :class="{'selected': selectedSection === section}"
                  style="vertical-align: middle;">

                <td class="col-sort handle" style="vertical-align: middle;">
                  <b-icon icon="arrow-down-up"></b-icon>
                </td>

                <td class="col-color" @click="selectSection(section)" style="vertical-align: middle;">
                  <div class="section-color" :style="{'background-color': colors[index]}"></div>
                </td>

                <td style="vertical-align: middle;">
                  <b-form-select
                    v-model="section.sectionType"
                    :options="sectionTypes"
                    value-field="sectionName"
                    text-field="printName">
                  </b-form-select>
                </td>

                <td style="vertical-align: middle; width: 50px;">
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <i v-if="section.error" style="margin: 0px; color: orange;"
                      class="material-icons right"
                      data-toggle="tooltip" :title="section.error">
                      report
                    </i>
                  </div>
                </td>

                <td style="vertical-align: middle;">
                  <b-form-input min="0" :max="totalSeconds" step="0.1" type="number" v-model="section.startTime" @change="plotBands()"></b-form-input>
                </td>

                <td style="vertical-align: middle;">
                  <b-form-input min="0" :max="totalSeconds" step="0.1" type="number" v-model="section.endTime" @change="plotBands()"></b-form-input>
                </td>

                <td class="col-trash" @click="removeSection(section)" style="vertical-align: middle;">
                  <b-icon icon="trash" font-scale="1.3"></b-icon>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <b-button variant="link" :disabled="sectionTypes.length <= sections.length || sections.length >= 10" @click="addSection()">{{ $t('views.switch.sections.addsection') }}</b-button>
          <b-button class="float-right" variant="link" @click="saveSection(selectedAsset, sections)">{{ $t('views.switch.sections.save') }}</b-button>
        </div>
      </div>
    </div>

    <div v-if="!selectedAsset.ParentRailObjectId">
      {{ $t('charts.nomotorselected') }}
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Highcharts from 'highcharts'
import AssetsService from '@/services/r8/AssetsService'
import PointAlarmsPrototypeService from '@/services/r8/PointAlarmsPrototypeService'
import UtilitiesService from '@/services/UtilitiesService'
import Translation from '../../../i18n/Translation'
import moment from 'moment'

export default {
  name: 'sectionchart',
  props: ['asset', 'selectedAsset'],
  components: {
    draggable
  },
  data () {
    return {
      loading: false,
      r8token: null,
      serverError: '',
      locale: 'nl-NL',
      totalSeconds: 0,
      sectionData: [],
      sectionDataSecond: [],
      dateTimeFrom: moment().add(-1, 'M').format('YYYY-MM-DDTHH:mm:ss'),
      dateTimeTo: moment().format('YYYY-MM-DDTHH:mm:ss'),
      sectionTypes: [],
      sections: [],
      directions: [
        {
          name: this.$t('views.switch.sections.normal'),
          id: 0
        },
        {
          name: this.$t('views.switch.sections.reverse'),
          id: 1
        },
        {
          name: this.$t('views.switch.sections.both'),
          id: 2
        }
      ],
      both: true,
      maxGraphHeigtht: 300,
      showNormalWhenBoth: true,
      selectedPosition: false,
      variableSectionStart: null,
      variableSectionEnd: null,
      selectedSection: null,
      colors: [
        '#88CCEE', // Light Blue
        '#44AA99', // Teal Green
        '#117733', // Dark Green
        '#DDCC77', // Sand Yellow
        '#CC6677', // Pink
        '#882255', // Dark Red
        '#AA4499', // Purple
        '#999933', // Olive
        '#332288', // Navy Blue
        '#E69F00'  // Orange
      ],
      sectionChartOptions: {
        chart: {
          height: '300px',
          animation: false,
          backgroundColor: '#f8f9fa',
          events: {
            selection: (event) => {
              this.selection(event)
            }
          },
          zooming: {
            mouseWheel: {
              enabled: false
            }
          }
        },
        colors: [
          '#292b2c',
          '#5bc0de'
        ],
        title: {
          text: ''
        },
        tooltip: {
          shared: true,
          formatter: function () {
            let tooltipText = `<b>${this.x.toFixed(2)} s</b><br/>`

            this.points.forEach(point => {
              if (point.series.type === 'line') {
                tooltipText += `Value: <b>${point.y.toFixed(2)}</b><br/>`
              } else if (point.series.type === 'arearange') {
                const low = point.point.low.toFixed(2)
                const high = point.point.high.toFixed(2)
                tooltipText += `Range: <b>[${low} - ${high}]</b><br/>`
              }
            })

            return tooltipText
          }
        },
        lang: {
          noData: this.$t('charts.nodata')
        },
        legend: {
          enabled: false
        },
        accessibility: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        yAxis: {
          min: 0,
          title: {
            text: null
          }
        },
        xAxis: {
          plotBands: [],
          title: {
            text: 'Time (s)'
          }
        },
        plotOptions: {
          series: {
            animation: false
          }
        },
        series: [{
          name: '',
          data: [],
          zIndex: 1,
          marker: {
            fillColor: 'white',
            lineWidth: 2,
            lineColor: Highcharts.getOptions().colors[0]
          }
        }]
      },
      sectionChartOptionsSecond: {
        chart: {
          height: '300px',
          animation: false,
          backgroundColor: '#f8f9fa',
          events: {
            selection: (event) => {
              this.selection(event)
            }
          },
          zooming: {
            mouseWheel: {
              enabled: false
            }
          }
        },
        colors: [
          '#292b2c',
          '#5bc0de'
        ],
        title: {
          text: ''
        },
        tooltip: {
          shared: true,
          formatter: function () {
            let tooltipText = `<b>${this.x.toFixed(2)} s</b><br/>`

            this.points.forEach(point => {
              if (point.series.type === 'line') {
                tooltipText += `Value: <b>${point.y.toFixed(2)}</b><br/>`
              } else if (point.series.type === 'arearange') {
                const low = point.point.low.toFixed(2)
                const high = point.point.high.toFixed(2)
                tooltipText += `Range: <b>[${low} - ${high}]</b><br/>`
              }
            })

            return tooltipText
          }
        },
        lang: {
          noData: this.$t('charts.nodata')
        },
        legend: {
          enabled: false
        },
        accessibility: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        yAxis: {
          min: 0,
          title: {
            text: null
          }
        },
        xAxis: {
          plotBands: [],
          title: {
            text: 'Time (s)'
          }
        },
        plotOptions: {
          series: {
            animation: false
          }
        },
        series: [{
          name: '',
          data: [],
          zIndex: 1,
          marker: {
            fillColor: 'white',
            lineWidth: 2,
            lineColor: Highcharts.getOptions().colors[0]
          }
        }]
      }
    }
  },
  created: async function () {
    await this.refreshData()
  },
  mounted: async function () {
    this.locale = Translation.getCurrentLanguage()
    await this.getR8Token()
    this.selectedPosition = 2
  },
  methods: {
    async getR8Token () {
      try {
        const result = await AssetsService.getToken(this.selectedAsset)
        this.r8token = result.token
      } catch (error) {
        console.error('Error while fetching token:', error)
        this.serverError = this.$t('views.switch.alarmsettings.errorfetchingtoken') + ': ' + error
      }
    },

    async refreshData () {
      if (this.selectedAsset.ParentRailObjectId !== null) {
        this.serverError = null
        await this.getR8Token()
        await this.getAssetSections()
        await this.loadPointMotorTurns()
        await this.loadSections()
      }
    },

    async loadPointMotorTurns () {
      try {
        this.loading = true
        let direction = true
        this.sectionChartOptions.chart.height = '300px'
        if (this.selectedPosition === 2) {
          direction = true
          this.both = true
        } else {
          direction = this.selectedPosition === 0
          this.both = false
        }

        this.sections = await PointAlarmsPrototypeService.getSectionsByDirection(
          this.selectedAsset,
          this.r8token,
          direction
        )

        this.sections.forEach(s => {
          s.error = ''
        })

        this.loadingPointMotorTurns = true

        if (!this.both) {
          this.sectionData = await PointAlarmsPrototypeService.getSingleReferenceCurve(
            this.selectedAsset,
            this.r8token,
            direction
          )
        } else {
          this.sectionData = await PointAlarmsPrototypeService.getSingleReferenceCurve(
            this.selectedAsset,
            this.r8token,
            true
          )
          this.sectionDataSecond = await PointAlarmsPrototypeService.getSingleReferenceCurve(
            this.selectedAsset,
            this.r8token,
            false
          )
        }

        // Apply limits
        const graph = this.sectionData.find(item => item.referenceType === 'Graph')
        const areaLow = this.sectionData.find(item => item.referenceType === 'AreaLow')
        const areaHigh = this.sectionData.find(item => item.referenceType === 'AreaHigh')

        if (graph) {
          const duration = graph.values.length * graph.sampleInterval
          const removeStart = graph.startTime / graph.sampleInterval
          const removeEnd = (duration - graph.endTime) / graph.sampleInterval
          graph.values = graph.values.slice(removeStart, graph.values.length - removeEnd)
          if (areaLow) {
            areaLow.values = areaLow.values.slice(removeStart, areaLow.values.length - removeEnd)
          }
          if (areaHigh) {
            areaHigh.values = areaHigh.values.slice(removeStart, areaHigh.values.length - removeEnd)
          }
        } else {
          this.serverError = 'Graph reference data not present'
        }

        if (this.both) {
          const graphSecond = this.sectionDataSecond.find(item => item.referenceType === 'Graph')
          const areaLowSecond = this.sectionDataSecond.find(item => item.referenceType === 'AreaLow')
          const areaHighSecond = this.sectionDataSecond.find(item => item.referenceType === 'AreaHigh')

          if (graphSecond && this.both) {
            const duration = graphSecond.values.length * graphSecond.sampleInterval
            const removeStart = graphSecond.startTime / graphSecond.sampleInterval
            const removeEnd = (duration - graph.endTime) / graphSecond.sampleInterval
            graphSecond.values = graphSecond.values.slice(removeStart, graphSecond.values.length - removeEnd)
            if (areaLow) {
              areaLowSecond.values = areaLowSecond.values.slice(removeStart, areaLowSecond.values.length - removeEnd)
            }
            if (areaHigh) {
              areaHighSecond.values = areaHighSecond.values.slice(removeStart, areaHighSecond.values.length - removeEnd)
            }
          } else {
            this.serverError = 'Graph reference data not present'
          }
        }
        this.loadingPointMotorTurns = false
        this.setData()
      } catch (err) {
        if (err.response && err.response.data) {
          const response = err.response.data
          if (response.errors) {
            const formattedErrors = Object.entries(response.errors)
              .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
              .join('\n')
            this.serverError = `Validation errors occurred:\n${formattedErrors}`
          } else if (response.title) {
            this.serverError = response.title
          } else if (err.response.data) {
            this.serverError = err.response.data
          } else {
            this.serverError = response.message || 'An unexpected error occurred.'
          }
        } else {
          this.serverError = err.message || 'An unexpected error occurred.'
        }
      } finally {
        this.loading = false
      }
    },

    async loadSections () {
      this.sections.forEach(section => {
        if (section.start === null || section.start === '') {
          this.setVariableSectionStart(section)
        }
        if (section.end === null || section.end === '') {
          this.setVariableSectionEnd(section)
        }
      })

      this.plotBands()
    },

    async getAssetSections () {
      try {
        this.sectionTypes = []
        const assetSections = await PointAlarmsPrototypeService.getAvailablesections(this.selectedAsset, this.r8token, this.locale)
        assetSections.forEach(as => {
          this.sectionTypes.push(as)
        })
      } catch (err) {
        console.log(err)
        if (err.response && err.response.data && err.response.data.errors) {
          const errors = err.response.data.errors
          const formattedErrors = Object.entries(errors)
            .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
            .join('\n')

          this.serverError = `Validation errors occurred:\n${formattedErrors}`
        } else {
          this.serverError = err.message || 'An unexpected error occurred.'
        }
      }
    },

    setData () {
      this.sectionChartOptions.series = [
        {
          name: 'Value',
          type: 'line',
          data: [],
          zIndex: 2,
          marker: {
            enabled: false,
            fillColor: 'white',
            lineWidth: 2,
            lineColor: Highcharts.getOptions().colors[0]
          }
        },
        {
          name: 'Range',
          type: 'arearange',
          data: [],
          zIndex: 1,
          color: Highcharts.getOptions().colors[1],
          fillOpacity: 0.3,
          lineWidth: 0,
          marker: {
            enabled: false
          }
        }
      ]

      this.sectionChartOptionsSecond.series = [
        {
          name: 'Value',
          type: 'line',
          data: [],
          zIndex: 2,
          marker: {
            enabled: false,
            fillColor: 'white',
            lineWidth: 2,
            lineColor: Highcharts.getOptions().colors[0]
          }
        },
        {
          name: 'Range',
          type: 'arearange',
          data: [],
          zIndex: 1,
          color: Highcharts.getOptions().colors[1],
          fillOpacity: 0.3,
          lineWidth: 0,
          marker: {
            enabled: false
          }
        }
      ]
      if (!this.sectionData) {
        return
      }

      const graph = this.sectionData.find(item => item.referenceType === 'Graph')
      const areaLow = this.sectionData.find(item => item.referenceType === 'AreaLow')
      const areaHigh = this.sectionData.find(item => item.referenceType === 'AreaHigh')

      if (graph && areaLow && areaHigh) {
        for (let i = 0; i < graph.values.length; i++) {
          const seconds = i * graph.sampleInterval
          this.sectionChartOptions.series[0].data.push([seconds, graph.values[i]])
          this.sectionChartOptions.series[1].data.push([seconds, areaLow.values[i], areaHigh.values[i]])
        }
      }
      this.plotBands()
      const graphSecond = this.sectionDataSecond.find(item => item.referenceType === 'Graph')
      const areaLowSecond = this.sectionDataSecond.find(item => item.referenceType === 'AreaLow')
      const areaHighSecond = this.sectionDataSecond.find(item => item.referenceType === 'AreaHigh')
      if (graphSecond && areaLowSecond && areaHighSecond) {
        for (let i = 0; i < graphSecond.values.length; i++) {
          const seconds = i * graphSecond.sampleInterval
          this.sectionChartOptionsSecond.series[0].data.push([seconds, graphSecond.values[i]])
          this.sectionChartOptionsSecond.series[1].data.push([seconds, areaLowSecond.values[i], areaHighSecond.values[i]])
        }
        this.plotBandsSecond()
      }
    },

    selection (event) {
      if (event.resetSelection) {
        // this.$emit('set-section', this.sectionData[0].seconds, this.sectionData[this.sectionData.length-1].seconds)
      } else {
        // this.$emit('set-section', event.xAxis[0].min, event.xAxis[0].max)
      }
    },

    selectSection (section) {
      if (this.selectedSection === section) {
        this.selectedSection = null
        this.plotBands()
        if (this.both) {
          this.plotBandsSecond()
        }
        return
      }
      this.selectedSection = section

      this.plotBands()
      if (this.both) {
        this.plotBandsSecond()
      }
    },

    removeSection (section) {
      this.sections = this.sections.filter(s => s !== section)
      this.plotBands()
    },

    plotBands () {
      const graph = this.sectionData.find(item => item.referenceType === 'Graph')

      if (!graph) {
        return
      }

      let totalSeconds = graph.values.length * graph.sampleInterval
      this.totalSeconds = totalSeconds

      this.sectionChartOptions.xAxis.plotBands = []
      this.sections.forEach((section, index) => {
        if (section.startTime === '') {
          section.startTime = null
        }
        if (section.endTime === '') {
          section.endTime = null
        }
        let opacity = this.selectedSection === section ? 1 : 0.4
        let start = parseFloat(section.startTime)
        let end = parseFloat(section.endTime)

        if (section.startTime === null || section.startTime === '') {
          if (this.sections[index - 1]) {
            start = parseFloat(this.sections[index - 1].endTime)
          } else {
            start = 0
          }
        }
        if (section.endTime === null || section.endTime === '' || section.endTime === 0) {
          if (this.sections[index + 1]) {
            end = parseFloat(this.sections[index + 1].startTime)
          } else {
            end = parseFloat(totalSeconds)
          }
        }

        if (start < 0) {
          start += parseFloat(totalSeconds)
        }

        if (end < 0) {
          end += parseFloat(totalSeconds)
        }

        this.sectionChartOptions.xAxis.plotBands.push({
          from: start,
          to: end,
          color: UtilitiesService.hexToRgbA(this.colors[index], opacity)
        })
      })
    },

    plotBandsSecond () {
      const graph = this.sectionData.find(item => item.referenceType === 'Graph')

      if (!graph) {
        return
      }

      let totalSeconds = graph.values.length * graph.sampleInterval
      this.totalSeconds = totalSeconds

      this.sectionChartOptionsSecond.xAxis.plotBands = []
      this.sections.forEach((section, index) => {
        if (section.startTime === '') {
          section.startTime = null
        }
        if (section.endTime === '') {
          section.endTime = null
        }
        let opacity = this.selectedSection === section ? 1 : 0.4
        let start = parseFloat(section.startTime)
        let end = parseFloat(section.endTime)

        if (section.startTime === null || section.startTime === '') {
          if (this.sections[index - 1]) {
            start = parseFloat(this.sections[index - 1].endTime)
          } else {
            start = 0
          }
        }
        if (section.endTime === null || section.endTime === '' || section.endTime === 0) {
          if (this.sections[index + 1]) {
            end = parseFloat(this.sections[index + 1].startTime)
          } else {
            end = parseFloat(totalSeconds)
          }
        }

        if (start < 0) {
          start += parseFloat(totalSeconds)
        }

        if (end < 0) {
          end += parseFloat(totalSeconds)
        }

        this.sectionChartOptionsSecond.xAxis.plotBands.push({
          from: start,
          to: end,
          color: UtilitiesService.hexToRgbA(this.colors[index], opacity)
        })
      })
    },

    setVariableSectionStart (section) {
      if (this.variableSectionStart === section) {
        this.variableSectionStart = null
        return
      }
      this.variableSectionStart = section
      section.start = null

      this.plotBands()
    },

    setVariableSectionEnd (section) {
      if (this.variableSectionEnd === section) {
        this.variableSectionEnd = null
        return
      }
      this.variableSectionEnd = section
      section.end = null

      // this.addMissingSectionValues()
      this.plotBands()
    },

    addMissingSectionValues () {
      this.sections.forEach((section, index) => {
        if ((section.start === null || section.start === '') && this.variableSectionStart !== section) {
          if (this.sections[index - 1]) {
            section.start = parseFloat(this.sections[index - 1].end)
          } else {
            section.start = 0
          }
        }
        if ((section.end === null || section.end === '') && this.variableSectionEnd !== section) {
          if (this.sections[index + 1]) {
            section.end = parseFloat(this.sections[index + 1].start)
          } else {
            section.end = parseFloat(this.sectionData[this.sectionData.length - 1].seconds)
          }
        }
      })
    },

    endSort () {
      this.plotBands()
    },

    addSection () {
      this.sections.push({
        name: null,
        startTime: null,
        endTime: null
      })
    },

    validateSections () {
      const sectionTypeCount = {}
      let hasErrors = false

      // Count occurrences of each sectionType
      this.sections.forEach(section => {
        if (section.sectionType !== undefined) {
          if (sectionTypeCount[section.sectionType]) {
            sectionTypeCount[section.sectionType]++
          } else {
            sectionTypeCount[section.sectionType] = 1
          }
        }
      })

      // Check for duplicates and set error field if necessary
      this.sections.forEach(section => {
        if (section.sectionType !== undefined) {
          if (sectionTypeCount[section.sectionType] > 1) {
            section.error = `Duplicate section type: ${section.sectionType}`
            hasErrors = true
          } else {
            section.error = ''
          }
        } else {
          section.error = 'Please fill section type'
          hasErrors = true
        }
      })

      return hasErrors
    },

    async saveSection (asset, sections) {
      try {
        if (this.validateSections()) {
          throw new Error('Please solve warnings first!')
        }
        let direction = true
        if (this.selectedPosition === null) {
          direction = true
          this.both = true
        } else {
          direction = this.selectedPosition === 0
          this.both = false
        }
        if (this.both) {
          sections.forEach((section, index) => {
            section.sectionOrderNumber = index + 1
            section.objectId = asset.UniqueId
            section.sectionDirection = 0
            section.asset = asset
          })
          sections.forEach((section, index) => {
            section.sectionOrderNumber = index + 1
            section.objectId = asset.UniqueId
            section.sectionDirection = 1
            section.asset = asset
          })
        } else {
          sections.forEach((section, index) => {
            section.sectionOrderNumber = index + 1
            section.objectId = asset.UniqueId
            section.sectionDirection = direction === true ? 0 : 1
            section.asset = asset
          })
        }
        await PointAlarmsPrototypeService.updateSections(asset, this.r8token, sections)

        this.$notify({
          group: 'alerts',
          type: 'success',
          title: 'Sections saved',
          duration: 1000,
          speed: 1000
        })
      } catch (err) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'Error while saving sections',
          text: '' + err,
          duration: 1000,
          speed: 1000
        })
      }
    }
  },
  computed: {
    // availableSectionNames: function () {
    //   let usedSectionNames = this.sections.map(s => s.name)
    //   return this.sectionNames.filter(sn => usedSectionNames.indexOf(sn) === -1)
    // }
  },
  watch: {
    sectionData () {
      this.setData()
    },
    sections: {
      handler () {
        this.validateSections()
      },
      deep: true
    },
    async selectedPosition () {
      if (this.selectedAsset.ParentRailObjectId !== null) {
        await this.loadPointMotorTurns()
      }
    },
    async selectedAsset () {
      await this.refreshData()
    }
  }
}
</script>

<style scoped src='bootstrap/dist/css/bootstrap.css'></style>
<style scoped src='bootstrap-vue/dist/bootstrap-vue.css'></style>
<style scoped>
#section-chart {
  width: 100%;
}
.cssGraph {
  width: 100%;
  height: 300px;
}
.section-color {
  width: 24px;
  height: 24px;
  opacity: 0.4;
  margin-top: 7px;
}

.col-variable-section {
  width: 24px;
  height: 24px;
  margin-top: 7px;
}

.col-sort {
  width: 24px;
  height: 24px;
}

.col-variable-section input {
  margin-top: 12px;
}

.selected .section-color {
  opacity: 1;
}

.col-color,
.col-trash,
.col-variable-section,
.col-sort {
  width: 40px;
  cursor: pointer;
}

.col-trash {
  padding-top: 20px;
}

.col-sort {
  padding-top: 18px;
}

.spinner {
    border: 6px solid #f3f3f3; /* Light grey */
    border-top: 6px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.highcharts-loading .spinner {
    border: 6px solid #f3f3f3; /* Light grey */
    border-top: 6px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 2s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000 !important; /* Ensure it's above all other elements */
}
</style>



// WEBPACK FOOTER //
// src/pages/switch/_sections/Sections.vue